import React from "react";
import { Button } from "@/components/ui/button";
import { Save, Download, Loader2 } from "lucide-react";
interface PrayerActionsProps {
  isGeneratingAudio: boolean;
  isAudioReady: boolean;
  onSave: () => void;
  onDownload: () => void;
}
const PrayerActions: React.FC<PrayerActionsProps> = ({
  isGeneratingAudio,
  isAudioReady,
  onSave,
  onDownload
}) => {
  return <div className="flex space-x-2">
      <Button onClick={onSave} variant="outline" className="flex items-center gap-2 border-selah-gold hover:bg-selah-gold/10" title="Save prayer to dashboard">
        <Save className="h-5 w-5 text-selah-gold" />
        <span className="hidden sm:inline">Save</span>
      </Button>
      
      <Button onClick={onDownload} variant="outline" className="flex items-center gap-2 border-selah-gold hover:bg-selah-gold/10" title="Download prayer audio" disabled={isGeneratingAudio || !isAudioReady}>
        {isGeneratingAudio ? <>
            <Loader2 className="h-5 w-5 text-selah-gold animate-spin" />
            <span className="hidden sm:inline">Generating...</span>
          </> : <>
            <Download className="h-5 w-5 text-selah-gold" />
            <span className="hidden sm:inline">Download MP3</span>
          </>}
      </Button>
    </div>;
};
export default PrayerActions;